import { DOCUMENT } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

import { CartService } from '../../core/services/cart/cart.service';
import { CartComponent } from '../../shared/components/cart/cart.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { WhatsappButtonComponent } from '../../shared/components/whatsapp-button/whatsapp-button.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  imports: [
    CartComponent,
    FooterComponent,
    HeaderComponent,
    MatSidenavModule,
    RouterOutlet,
    WhatsappButtonComponent,
  ],
})
export class MainLayoutComponent {
  protected readonly cartService = inject(CartService);
  private readonly document = inject(DOCUMENT);

  constructor() {
    effect(() => {
      this.document.body.style.overflow = this.cartService.isOpen()
        ? 'hidden'
        : '';
    });
  }
}
